import { type ComponentProps, type GatsbyCustomImage } from "@ts/components";
import { type ProductVideo } from "@ts/sanity";
import React, { type FC } from "react";

type VideoProps = ComponentProps & {
  video?: Partial<ProductVideo>;
  videoBackground?: GatsbyCustomImage;
  playing?: boolean;
};

export const withVideo =
  (Component: FC<VideoProps>) =>
  ({ name = "Video", analytics = {}, muted = true, ...props }: VideoProps) => {
    Component.displayName = name;
    return <Component {...props} muted={muted} />;
  };
